import { render, staticRenderFns } from "./ModalWrapper.vue?vue&type=template&id=a09caba8&"
import script from "./ModalWrapper.vue?vue&type=script&lang=js&"
export * from "./ModalWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ModalWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports